module.exports = __webpack_public_path__ + "static/media/avatar3.10344201.jpg";